import { toast, ToastOptions } from 'react-toastify';

export const showToast = {
  success: (message: string, options?: ToastOptions) => {
    toast.success(message, {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options,
    });
  },

  error: (message: string, options?: ToastOptions) => {
    toast.error(message, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options,
    });
  },

  warning: (message: string, options?: ToastOptions) => {
    toast.warning(message, {
      position: 'top-right',
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options,
    });
  },

  info: (message: string, options?: ToastOptions) => {
    toast.info(message, {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      ...options,
    });
  },

  loading: (message: string, options?: ToastOptions) => {
    return toast.loading(message, {
      position: 'top-right',
      ...options,
    });
  },

  dismiss: (toastId: string | number) => {
    toast.dismiss(toastId);
  },
};

export const toastMessages = {
  cliente: {
    created: 'Cliente cadastrado com sucesso!',
    updated: 'Cliente atualizado com sucesso!',
    deleted: 'Cliente excluído com sucesso!',
    error: 'Erro ao processar cliente',
  },
  produto: {
    created: 'Produto cadastrado com sucesso!',
    updated: 'Produto atualizado com sucesso!',
    deleted: 'Produto excluído com sucesso!',
    error: 'Erro ao processar produto',
  },
  reserva: {
    created: 'Reserva criada com sucesso!',
    updated: 'Reserva atualizada com sucesso!',
    deleted: 'Reserva excluída com sucesso!',
    error: 'Erro ao processar reserva',
  },
  auth: {
    loginSuccess: 'Login realizado com sucesso!',
    logoutSuccess: 'Logout realizado com sucesso!',
    registerSuccess: 'Conta criada com sucesso!',
    error: 'Erro de autenticação',
  },
  geral: {
    loading: 'Carregando...',
    saving: 'Salvando...',
    deleting: 'Excluindo...',
    success: 'Operação realizada com sucesso!',
    error: 'Ocorreu um erro inesperado',
  },
};
